import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { customSelectStyles } from "../../utils/reactSelectStyles";
import MarkdownEditor from "../MarkdownEditor/MarkdownEditor";

/**
 * Renders a single custom field input based on its field_type.
 *
 * Props:
 *   champ    - the custom field object (from /client/{id}/champs)
 *   value    - current value (string)
 *   onChange - callback(newValue: string)
 */
const FIELD_TYPE_MAP = {
  Texte:     "text",
  Nombre:    "number",
  Date:      "date",
  DateHeure: "datetime-local",
  Email:     "email",
};

const CustomFieldInput = ({ champ, value, onChange, onBlur }) => {
  const label = (
    <Form.Label>
      {champ.label}
      {champ.is_required && <span className="text-danger ms-1">*</span>}
    </Form.Label>
  );

  const typeName = champ.field_type?.name;

  if (typeName === "Checkbox") {
    const isChecked = value === "1" || value === 1 || value === true;
    return (
      <Form.Group className="mb-3">
        <Form.Check
          type="switch"
          id={`champ-${champ.id}`}
          label={
            <>
              {champ.label}
              {champ.is_required && <span className="text-danger ms-1">*</span>}
            </>
          }
          checked={isChecked}
          onChange={e => onChange(e.target.checked ? "1" : "0")}
        />
      </Form.Group>
    );
  }

  if (typeName === "Select") {
    const options = (champ.field_options ?? []).map(opt => ({
      value: opt.value,
      label: opt.label,
    }));
    const selected = options.find(o => o.value === value) ?? null;
    return (
      <Form.Group className="mb-3">
        {label}
        <Select
          options={options}
          value={selected}
          onChange={opt => onChange(opt ? opt.value : "")}
          isClearable={!champ.is_required}
          placeholder={champ.placeholder || "Sélectionner..."}
          styles={customSelectStyles}
          noOptionsMessage={() => "Aucune option disponible"}
        />
      </Form.Group>
    );
  }

  if (typeName === "Textarea") {
    return (
      <Form.Group className="mb-3">
        {label}
        <MarkdownEditor
          value={value ?? ""}
          onChange={onChange}
          rows={3}
          placeholder={champ.placeholder || ""}
          required={champ.is_required}
        />
      </Form.Group>
    );
  }

  const inputType = FIELD_TYPE_MAP[typeName] ?? "text";

  return (
    <Form.Group className="mb-3">
      {label}
      <Form.Control
        type={inputType}
        placeholder={champ.placeholder || ""}
        value={value ?? ""}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        required={champ.is_required}
      />
    </Form.Group>
  );
};

export default CustomFieldInput;
